import React from 'react';

import { useAppSelector } from 'store/hooks';
import { PortalConfigSelector } from 'store/config/selectors';

import { ReactComponent as WarningIcon } from 'assets/error.icon.svg';

import useStyles from './styles';

const SLABanner: React.FC = () => {
  const classes = useStyles();
  const config = useAppSelector(PortalConfigSelector);

  if (!config?.slaBanner) return null;
  return (
    <div className={classes.container}>
      <WarningIcon className={classes.icon} />
      <div className={classes.text}>{config?.slaBanner}</div>
    </div>
  );
};

export default SLABanner;
